// extracted by mini-css-extract-plugin
export var businessHoursList = "business-hours-module--business-hours-list--1uJN1";
export var headline = "business-hours-module--headline--rCurU";
export var headlineWrapper = "business-hours-module--headline-wrapper--JSPWo";
export var highlightText = "business-hours-module--highlight-text--z59Dr";
export var infoIcon = "business-hours-module--info-icon--eiILM";